import * as React from 'react';

import PageInfoContext from 'bundles/unified-seo-content-common/contexts/PageInfoContext';
import type { PageInfo } from 'bundles/unified-seo-content-common/contexts/PageInfoContext';

type Props = PageInfo & {
  children: React.ReactNode;
};

const PageInfoProvider = ({ pageType, children }: Props) => {
  return <PageInfoContext.Provider value={{ pageType }}>{children}</PageInfoContext.Provider>;
};

export default PageInfoProvider;
